(ns app.front.ui.locale-select
  (:require ["@base-ui/react/select$Select" :as base-select]
            ["@carbon/icons-react/es/chevron--down/16" :default ChevronDown16]
            [app.front.util :as futil]
            [reagent.core :as r]))

(defn locale-select
  "Compact locale selector. Options have string :value, :label, :trigger-label and optional :icon-src.
   The trigger shows the current locale; the popup lists only alternatives."
  [{:keys [value options label on-change align trigger-class]}]
  (let [selected (some #(when (= value (:value %)) %) options)]
    [:div.flex.flex-1.md:flex-initial.min-w-0
     [:> base-select/Root
      {:value                   value
       :items                   (->> options
                                     (map #(select-keys % [:value :label]))
                                     clj->js)
       :modal                   false
       :highlight-item-on-hover false
       :on-value-change         #(some-> % on-change)}
      [:> base-select/Trigger
       {:class-name (str "flex items-center w-full h-full px-2 py-3 border border-solid border-gray-600 "
                         "focus:shadow-none -outline-offset-2 focus:outline-ui-blue-100 focus:outline-solid focus:outline-2 "
                         "bg-white text-gray-600 hover:text-gray-700 hover:bg-gray-100 text-sm whitespace-nowrap " trigger-class)
        :aria-label (str label ": " (:trigger-label selected))}
       [:> base-select/Value
        {:class-name "flex-1 min-w-0 text-left truncate"}
        (:trigger-label selected)]
       [:span.shrink-0.text-right.mx-2.text-xs.font-bold label]
       [:> base-select/Icon
        {:class-name "flex-none data-[popup-open]:rotate-180 transition-transform ease-out duration-150 pt-1 -my-1"}
        [:> ChevronDown16]]]
      [:> base-select/Portal
       [:> base-select/Positioner
        {:align                   (or align "start")
         :side                    "bottom"
         :collision-padding       0
         :align-item-with-trigger false
         :class-name              "z-[9999]"}
        [:> base-select/Popup
         {:class-name (str "bg-white border border-solid border-gray-300 shadow-lg whitespace-nowrap -mx-px "
                           "min-w-[calc(var(--anchor-width)+2px)] max-h-[var(--available-height)] overflow-auto")}
         [:> base-select/List {:aria-label label}
          (futil/for-frag [{:keys [value label icon-src]} (remove #(= value (:value %)) options)]
            [:> base-select/Item
             {:value      value
              :label      label
              :class-name (str "flex items-center p-2 text-gray-600 text-sm cursor-pointer "
                               "hover:text-gray-700 data-[highlighted]:text-gray-700 "
                               "hover:bg-gray-100 data-[highlighted]:bg-gray-100 "
                               "data-[highlighted]:outline-2 data-[highlighted]:outline-solid "
                               "data-[highlighted]:outline-ui-blue-100 -outline-offset-2")}
             (when icon-src [:img.h-4.w-6.mr-2 {:src icon-src :alt ""}])
             [:> base-select/ItemText label]])]]]]]]))

(defn locale-select-wrapper
  "Wrapper to handle properly rounded borders and other styling for contained locale-select components"
  [props & children]
  (into
    [:div.flex.w-full.max-w-full.justify-end.divide-x.divide-gray-300.divide-solid
     (r/merge-props {:class ["[&>div]:max-w-1/2 [&>div:only-child]:max-w-full"
                             "[&>div]:border-solid [&>div]:border-gray-300 [&>div]:border-t"
                             "[&>div:first-child]:border-l [&>div:last-child]:border-r"
                             "md:[&>div:first-child]:rounded-tl md:[&>div:last-child]:rounded-tr"
                             "[&>div>button]:border-0 [&>div>button]:rounded-none"
                             "md:[&>div:first-child>button]:rounded-tl-[3px] md:[&>div:last-child>button]:rounded-tr-[3px]"
                             "[&>div>button]:relative [&>div>button:focus]:z-1"]}
                    props)]
    children))
